import {UnitTitle} from './unitTitle.mjs';
import {PageName} from './pageName.mjs';
import {Whitespace} from './whitespace.mjs';
import {InvalidLine} from './invalidLine.mjs';

const courseRules = Object.freeze([new UnitTitle(), new PageName(), new Whitespace(), new InvalidLine()]);

export {courseRules};
